var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlathers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1200px",
    height: "1200px",
    viewBox: "0 0 1200 1200",
    style: {
      enableBackground: "new 0 0 1200 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#5A4328;}\n\t.st1{fill:#F3F1E3;}\n\t.st2{fill:#FAFEC2;}\n\t.st3{fill:#2AB084;}\n\t.st4{fill:#248061;}\n\t.st5{fill:#F3DB3F;}\n\t.st6{fill:#EEECDE;}\n\t.st7{fill:#A7770F;}\n\t.st8{fill:#7C7B67;}\n\t.st9{fill:#F0F8FB;}\n\t.st10{fill:#000004;}\n\t.st11{fill:#D16046;}\n\t.st12{fill:#FDEC47;}\n\t.st13{fill:#775934;}\n\t.st14{fill:#231F14;}\n\t.st15{fill:#DCDACE;}\n\t.st16{fill:none;stroke:#000000;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "illustration_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M848.1,432c3.6-13.5-13.4-26.7-42.5-30.6c29-0.5,72.2,2.6,72.9-14.1c0.7-17.7-22.2-17.6-50.4-18.8 c29.6-5.4,50.8-13.9,47.4-26c-4.7-17-38.4-6.9-66.1-1.2c-13.2,2.7-25.3,1.1-35.7-0.7c-39.5-6.9-65.2-35.3-51.3-52.5 c11.7-14.5,15.1-36.4,15.1-56c0-46.6-28.9-84.4-112-84.4c-92.5,0-112,37.8-112,84.4c0,21.7,5.9,45.2,19.5,56.4 c16.4,13.5-14.5,45.1-54.4,52.1c-10.4,1.8-22.5,3.4-35.7,0.7c-27.6-5.7-61.3-15.8-66.1,1.2c-3.4,12.1,17.8,20.6,47.4,26 c-28.2,1.2-51.1,1.1-50.4,18.8c0.7,16.7,43.9,13.7,72.9,14.1c-29.1,3.9-47.5,17.6-42.5,30.6c8,20.8,38.4,23.2,73.6,8 c43.3-18.6,45.6-22.3,45.6-22.3c6.7,26.2,22.6,46.5,58.3,55.1c9.8,2.4,21,3.9,33.9,4.4c3.4,0.1,6.8,0.2,10.4,0.2 c5.5,0,10.8-0.2,15.8-0.5c55.5-3.7,78.4-27.7,86.8-60.8c0,0,6.5,3.5,50.5,24.8C818.9,460,843.3,449.8,848.1,432z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M714.9,399.3c1.7-37.9-21.1-92.1-88.7-92.1c-69.4,0-85.1,56.4-84,90.8c1.3,40.8,53.3,69.4,84,69.7 C656.9,468,713.2,436.3,714.9,399.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 625.6,
    cy: 232,
    rx: 101.6,
    ry: 76.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "jawMid_1_",
    cx: 624.5,
    cy: 290.7,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw7_1_",
    cx: 609.5,
    cy: 287.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw6_1_",
    cx: 599.5,
    cy: 280.8,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw5_1_",
    cx: 587.9,
    cy: 268.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw4_1_",
    cx: 581.1,
    cy: 248.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw3_1_",
    cx: 580.3,
    cy: 226.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw2_1_",
    cx: 580.3,
    cy: 217.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw1_1_",
    cx: 581.1,
    cy: 205.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw0_1_",
    cx: 583.6,
    cy: 196.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "topMid_1_",
    cx: 624.7,
    cy: 170,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftTop0_1_",
    cx: 644.4,
    cy: 172.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftTop1_1_",
    cx: 657,
    cy: 182,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw7_1_",
    cx: 639.3,
    cy: 287.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw6_1_",
    cx: 649.3,
    cy: 281.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw5_1_",
    cx: 660.9,
    cy: 268.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw4_1_",
    cx: 667.7,
    cy: 248.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw3_1_",
    cx: 668.5,
    cy: 227,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw2_1_",
    cx: 668.5,
    cy: 217.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw1_1_",
    cx: 667.7,
    cy: 205.7,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw0_1_",
    cx: 665.2,
    cy: 196.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightTop0_1_",
    cx: 604.8,
    cy: 172.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightTop1_1_",
    cx: 592.2,
    cy: 182,
    r: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M659,309c3.3-6.1,2.8-8.1,2.9-17.3c-15.8-3.5-21.9,5.2-29.4,14.1c-0.8-2.6-2.8-4.2-7-4.2 c-4.5,0-6.4,1.7-7.1,4.2c-7.5-8.9-13.6-17.6-29.3-14.1c0.1,9.2-0.4,11.2,2.9,17.3c-3.1,6.1-5.7,7.9-2.9,16.1 c8.4,2.8,16.9,2.4,29.9-8.1c1.1,2.2,3.1,3.6,6.6,3.6c3.5,0,5.5-1.4,6.5-3.5c13,10.5,21.5,10.9,29.9,8.1 C664.7,316.9,662.1,315.2,659,309z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M652.6,308.8c-0.3-4.9-10-3.2-17.3-0.8c-0.2-1.9-0.7-3.2-1.8-3.2c-1.8,0-1.9,2.9-1.9,6.4 c0,3.5,0.4,6.4,1.9,6.4c1.4,0,1.9-2.5,1.9-5.8C645.1,314.9,652.9,313.8,652.6,308.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M617.8,304.8c-1.1,0-1.6,1.3-1.8,3.2c-7.3-2.4-17-4.1-17.3,0.8c-0.3,5,7.5,6.1,17.2,3c0,3.2,0.5,5.8,1.9,5.8 c1.5,0,1.9-2.9,1.9-6.4C619.7,307.6,619.6,304.8,617.8,304.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M619.9,520.6c-2.2-4.8-7.3-12.8-9.1-15.6c0,0,0,0,0,0c-5.8-14.9-2.8-10.3,2.2-27.9 c-14.7-1.3-28.6-3.7-28.6-3.7c4.1,15.5,7.6,11.5,2.4,27.4c-16.6-1.5-36.9-0.2-44.5,13.5c3.7,1.1,7.3,2.1,10.9,2.8 c-6,4-10.5,8.8-12.2,14.2c10.6,1,22.7-0.9,34.2-3.6c-0.9,2.2-1.6,4.5-2,7C594.6,533.8,604.1,527,619.9,520.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M542.3,514.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M559.5,518.4c-5.5-0.9-11.3-2.3-17.2-4.1c3.4-6.2,9.3-9.8,16.4-11.8C561.4,509.4,559.5,518.4,559.5,518.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M564.5,530c-6.9,1-17.2,2-23.6,1.4c2.1-6.6,8.5-12.3,16.6-16.9C566.4,516.7,564.5,530,564.5,530z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M589.3,532.6c-4.7,1.1-9.9,1.9-16.2,2.2c1.3-7.9,3.5-20.1,10.5-18.9C588.7,524.6,589.3,532.6,589.3,532.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M587.1,481.6c4.7,1.8,16.8,4.9,23.5,2.9l-1.9,4.9c0,0-12.1,0.6-20-3.8L587.1,481.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M589.3,492.4c5.5,3.7,10.7,5,18.1,4.7l1.3,2.6c0,0-12.1,0.6-20-3.8L589.3,492.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M586.7,500.4c7,6.6,17.8,6.3,25.2,6l1.3,3.6c0,0-21.5-1-27.1-6.1L586.7,500.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M637.3,519.6c2.2-4.8,7.3-12.8,9.1-15.6c0,0,0,0,0,0c5.8-14.9,2.8-10.3-2.2-27.9c14.7-1.3,28.6-3.7,28.6-3.7 c-4.1,15.5-7.6,11.5-2.4,27.4c16.6-1.5,36.9-0.2,44.5,13.5c-3.7,1.1-7.3,2.1-10.9,2.8c6,4,10.5,8.8,12.2,14.2 c-10.6,1-22.7-0.9-34.2-3.6c0.9,2.2,1.6,4.5,2,7C662.6,532.8,653.1,526,637.3,519.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M714.9,513.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M697.7,517.4c5.5-0.9,11.3-2.3,17.2-4.1c-3.4-6.2-9.3-9.8-16.4-11.8C695.8,508.4,697.7,517.4,697.7,517.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M692.7,529c6.9,1,17.2,2,23.6,1.4c-2.1-6.6-8.5-12.3-16.6-16.9C690.8,515.7,692.7,529,692.7,529z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M667.9,531.6c4.7,1.1,9.9,1.9,16.2,2.2c-1.3-7.9-3.5-20.1-10.5-18.9C668.5,523.6,667.9,531.6,667.9,531.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M670.1,480.6c-4.7,1.8-16.8,4.9-23.5,2.9l1.9,4.9c0,0,12.1,0.6,20-3.8L670.1,480.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M667.9,491.4c-5.5,3.7-10.7,5-18.1,4.7l-1.3,2.6c0,0,12.1,0.6,20-3.8L667.9,491.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M670.5,499.4c-7,6.6-17.8,6.3-25.2,6l-1.3,3.6c0,0,21.5-1,27.1-6.1L670.5,499.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 565,
    cy: 220.6,
    r: 37.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 565,
    cy: 220.6,
    r: 32.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st10",
    cx: 558.4,
    cy: 209.5,
    rx: 9.8,
    ry: 13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 544.4,
    cy: 266.2,
    r: 24.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightEye0_1_",
    cx: 594.7,
    cy: 215.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightEye1_1_",
    cx: 599.9,
    cy: 211.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightEye5_1_",
    cx: 599.9,
    cy: 217.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightEye2_1_",
    cx: 606.2,
    cy: 211.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightEye3_1_",
    cx: 611.4,
    cy: 215.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightEye4_1_",
    cx: 606.2,
    cy: 216.6,
    r: 0.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 685.5,
    cy: 220.6,
    r: 37.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 685.5,
    cy: 220.6,
    r: 32.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st10",
    cx: 692.1,
    cy: 209.5,
    rx: 10.1,
    ry: 13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 706.9,
    cy: 266.2,
    r: 24.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftEye0_1_",
    cx: 654.3,
    cy: 215.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftEye1_1_",
    cx: 649.1,
    cy: 211.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftEye5_1_",
    cx: 649.1,
    cy: 217.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftEye2_1_",
    cx: 642.8,
    cy: 211.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftEye3_1_",
    cx: 637.6,
    cy: 215.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftEye4_1_",
    cx: 642.8,
    cy: 216.6,
    r: 0.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M511.8,96.1c-12.2,16.2-14.5,25.9-12.5,42.6c3.6,31.3,99.5,30.5,102.9,97.4c11.7-9.8,38.1-9.5,49.9,0 c1.4-65.4,94.5-66.2,98.1-97.4c1.9-16.6-0.3-26.4-12.5-42.6c-4.4,27.1-60.8,51.6-112,51.6S517.2,118.6,511.8,96.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw0_2_",
    cx: 583.6,
    cy: 196.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "topMid_2_",
    cx: 624.7,
    cy: 170,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftTop0_2_",
    cx: 644.4,
    cy: 172.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftTop1_2_",
    cx: 657,
    cy: 182,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw0_2_",
    cx: 665.2,
    cy: 196.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightTop0_2_",
    cx: 604.8,
    cy: 172.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightTop1_2_",
    cx: 592.2,
    cy: 182,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightBrow1_1_",
    cx: 592.5,
    cy: 203.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightBrow4_1_",
    cx: 615.8,
    cy: 206.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightBrow3_1_",
    cx: 606,
    cy: 202.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightBrow0_1_",
    cx: 588.5,
    cy: 206.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightBrow2_1_",
    cx: 598.7,
    cy: 202.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftBrow1_1_",
    cx: 656.2,
    cy: 203.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftBrow4_1_",
    cx: 632.6,
    cy: 205.7,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftBrow3_1_",
    cx: 642.6,
    cy: 202.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftBrow0_1_",
    cx: 660.2,
    cy: 206.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftBrow2_1_",
    cx: 649.9,
    cy: 202.1,
    r: 0.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M660.5,250.1c1.6-15-11.7-39.3-35.4-39.3c-24.6,0-34.7,27.4-32.7,39.3c4.4,26.6,19.8,36.7,36,36.7 C644.9,286.8,657.7,276.1,660.5,250.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M594.3,251c6-1.1,19.8-0.9,33.2-0.9c11.5,0,23.2,0.2,31.7,1.6c-7.8,2.9-18,7.9-31,7.8 C613.4,259.4,599.1,253,594.3,251z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightMouthCorner_1_",
    cx: 596.3,
    cy: 251.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "rightMiddleLip_1_",
    d: "M606.2,253.3c0.4,0,0.8,0.4,0.8,0.8s-0.4,0.8-0.8,0.8s-0.8-0.4-0.8-0.8 C605.4,253.7,605.8,253.3,606.2,253.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "upperLipBottomMid_1_",
    cx: 628.3,
    cy: 251.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lowerLipTopMid_1_",
    cx: 628.1,
    cy: 259.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightUpperLipBottom1_1_",
    cx: 613.2,
    cy: 251.8,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightLowerLipTop0_1_",
    cx: 616.6,
    cy: 256.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftMouthCorner_1_",
    cx: 657.4,
    cy: 252.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "leftMiddleLip_1_",
    d: "M649.1,253.8c0.4,0,0.8,0.4,0.8,0.8s-0.4,0.8-0.8,0.8s-0.8-0.4-0.8-0.8 C648.3,254.2,648.7,253.8,649.1,253.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftUpperLipBottom1_1_",
    cx: 642.8,
    cy: 251.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftLowerLipTop0_1_",
    cx: 639.3,
    cy: 256.2,
    r: 0.8
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M921.6,447.8c-4,24.3-40.4,19.7-81.2,11.8c-72.8-14.1-75.5-37.8-72.7-51.1c2.5-11.6,36.5-8.4,70.3-3.4 c-19.2-5-31.7-12.7-31.3-20.9c0.2-5,5.3-9.5,13.6-13c-7.6-1.5-12.5-4.5-13.8-8.8c-3.6-12.4,24.3-31.5,62.4-42.5s68.6-21.4,75.5,2.5 c6.3,21.9-22.6,30.9-59.2,41.6c36.9,1.5,65.9,2.6,64.9,26.2c-1,23.5-33.1,23.2-72.7,20.5C914.8,423.3,924.1,433.2,921.6,447.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M757.6,410.2c2.2-10.2,22.6-14.8,48.7-12.1c-10.4-4-16.7-9.2-16.5-14.6c0.2-3.7,3.4-7,8.8-9.8 c-4.5-1.4-7.4-3.7-8.3-6.6c-3.1-10.6,20.7-26.8,53.2-36.2c32.4-9.4,58.4-18.2,64.3,2.1c5,17.3-15.9,25.2-43.9,33.5 c27.9,1.2,48.9,3.5,48.1,22c-0.8,20-28.2,18.9-61.9,17.5c-1.1,0-2.2-0.1-3.2-0.2c23.8,5.7,40.1,12.7,36,31.4 c-4.9,22.6-35.6,21.1-70.2,13.6C778.1,443.4,754.9,422.7,757.6,410.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M848.1,432c3.6-13.5-13.4-26.7-42.5-30.6c29-0.5,72.2,2.6,72.9-14.1c0.7-17.7-22.2-17.6-50.4-18.8 c29.6-5.4,50.8-13.9,47.4-26c-4.7-17-38.4-6.9-66.1-1.2c-27.1,5.6-53.4,1.8-70,29.7c-2.9,4.9-5,10.3-5.3,15.9 c-0.3,7.4,2.9,14.6,6.9,20.9c13.6,21,44.3,40.2,69.3,43.1C825.3,452.3,843.7,448.4,848.1,432z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M330.9,447.8c4,24.3,40.4,19.7,81.2,11.8c72.8-14.1,75.5-37.8,72.7-51.1c-2.5-11.6-36.5-8.4-70.3-3.4 c19.2-5,31.7-12.7,31.3-20.9c-0.2-5-5.3-9.5-13.6-13c7.6-1.5,12.5-4.5,13.8-8.8c3.6-12.4-24.3-31.5-62.4-42.5s-68.6-21.4-75.5,2.5 c-6.3,21.9,22.6,30.9,59.2,41.6c-36.9,1.5-65.9,2.6-64.9,26.2c1,23.5,33.1,23.2,72.7,20.5C337.7,423.3,328.4,433.2,330.9,447.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M494.9,410.2c-2.2-10.2-22.6-14.8-48.7-12.1c10.4-4,16.7-9.2,16.5-14.6c-0.2-3.7-3.4-7-8.8-9.8 c4.5-1.4,7.4-3.7,8.3-6.6c3.1-10.6-20.7-26.8-53.2-36.2c-32.4-9.4-58.4-18.2-64.3,2.1c-5,17.3,15.9,25.2,43.9,33.5 c-27.9,1.2-48.9,3.5-48.1,22c0.8,20,28.2,18.9,61.9,17.5c1.1,0,2.2-0.1,3.2-0.2c-23.8,5.7-40.1,12.7-36,31.4 c4.9,22.6,35.6,21.1,70.2,13.6C474.4,443.4,497.6,422.7,494.9,410.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M519.9,374.2c-3.3-10.1-11.2-19.1-20.6-24.4c-22.2-12.7-51.7-7.9-76.1-12.9c-11-2.3-41.6-11.2-46.3,5.5 c-3.4,12.1,17.8,20.6,47.4,26c-28.2,1.2-51.1,1.1-50.4,18.8c0.7,16.7,43.9,13.7,72.9,14.1c-29.1,3.9-47.5,17.6-42.5,30.6 c9.2,18.5,29.9,19.7,48.3,16.1c28.9-5.1,49.7-16.4,63.1-43.5c2.5-5.1,4.8-10.4,5.6-16.1C522,383.6,521.4,378.8,519.9,374.2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "skeleton_1_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "rightShoulder",
    cx: 572.3,
    cy: 365.3,
    r: 8.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightElbow",
    cx: 519.5,
    cy: 365.1,
    r: 8.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightWrist",
    cx: 393.8,
    cy: 366.1,
    r: 8.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightHip",
    cx: 581.1,
    cy: 564.1,
    r: 8.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightKnee",
    cx: 575.6,
    cy: 725.2,
    r: 8.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightAnkle",
    cx: 575.6,
    cy: 933.2,
    r: 8.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftShoulder",
    cx: 681.3,
    cy: 365.4,
    r: 8.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftElbow",
    cx: 735.3,
    cy: 365.1,
    r: 8.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftWrist",
    cx: 860.6,
    cy: 365.1,
    r: 8.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftHip",
    cx: 673.1,
    cy: 563.3,
    r: 8.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftKnee",
    cx: 685.6,
    cy: 725.2,
    r: 8.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftAnkle",
    cx: 685.6,
    cy: 933.2,
    r: 8.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "572.2,365.6 581,564.4 673,563.6 681.2,365.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st16",
    points: "571.2,365.6 519.2,365.3 393.6,366.2  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st16",
    points: "682.7,365.3 735.5,365.3 860.7,365.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st16",
    points: "581,564.4 575.5,725.5 575.5,933.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st16",
    points: "673,563.6 685.5,725.5 685.5,933.5  "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightEye0",
    cx: 594.7,
    cy: 215.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightBrow1",
    cx: 592.5,
    cy: 203.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightBrow4",
    cx: 615.8,
    cy: 206.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "nose1",
    cx: 623.7,
    cy: 216.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightBrow3",
    cx: 606,
    cy: 202.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightEye1",
    cx: 599.9,
    cy: 211.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightBrow0",
    cx: 588.5,
    cy: 206.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightBrow2",
    cx: 598.7,
    cy: 202.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightEye5",
    cx: 599.9,
    cy: 217.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightEye2",
    cx: 606.2,
    cy: 211.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightEye3",
    cx: 611.4,
    cy: 215.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "nose0",
    cx: 623.7,
    cy: 210.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "nose3",
    cx: 623.7,
    cy: 228.7,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightNose0",
    cx: 613,
    cy: 233.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightMouthCorner",
    cx: 607,
    cy: 255.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightNose1",
    cx: 618.2,
    cy: 233.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightUpperLipTop0",
    cx: 613.9,
    cy: 251.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "nose2",
    cx: 623.7,
    cy: 221.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "nose4",
    cx: 623.7,
    cy: 234,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "upperLipTopMid",
    cx: 624.5,
    cy: 251.7,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightUpperLipTop1",
    cx: 620.4,
    cy: 250.8,
    r: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "rightMiddleLip",
    d: "M610.6,254.8c0.4,0,0.8,0.4,0.8,0.8c0,0.4-0.4,0.8-0.8,0.8s-0.8-0.4-0.8-0.8S610.2,254.8,610.6,254.8z "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lowerLipBottomMid",
    cx: 624.5,
    cy: 264.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "upperLipBottomMid",
    cx: 624.5,
    cy: 255.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lowerLipTopMid",
    cx: 624.5,
    cy: 258.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightUpperLipBottom1",
    cx: 620.6,
    cy: 254.8,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightLowerLipTop0",
    cx: 620.6,
    cy: 257.7,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightLowerLipBottom1",
    cx: 620.4,
    cy: 264.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightLowerLipBottom0",
    cx: 613.4,
    cy: 261.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightEye4",
    cx: 606.2,
    cy: 216.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "jawMid",
    cx: 624.5,
    cy: 290.7,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw7",
    cx: 609.5,
    cy: 287.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw6",
    cx: 599.5,
    cy: 280.8,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw5",
    cx: 587.9,
    cy: 268.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw4",
    cx: 581.1,
    cy: 248.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw3",
    cx: 580.3,
    cy: 226.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw2",
    cx: 580.3,
    cy: 217.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw1",
    cx: 581.1,
    cy: 205.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw0",
    cx: 583.6,
    cy: 196.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "topMid",
    cx: 624.7,
    cy: 170,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftTop0",
    cx: 644.4,
    cy: 172.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftTop1",
    cx: 657,
    cy: 182,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftEye0",
    cx: 654.3,
    cy: 215.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftBrow1",
    cx: 656.2,
    cy: 203.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftBrow4",
    cx: 632.6,
    cy: 205.7,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftBrow3",
    cx: 642.6,
    cy: 202.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftEye1",
    cx: 649.1,
    cy: 211.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftBrow0",
    cx: 660.2,
    cy: 206.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftBrow2",
    cx: 649.9,
    cy: 202.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftEye5",
    cx: 649.1,
    cy: 217.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftEye2",
    cx: 642.8,
    cy: 211.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftEye3",
    cx: 637.6,
    cy: 215.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftNose0",
    cx: 634.1,
    cy: 233.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftMouthCorner",
    cx: 642,
    cy: 255.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftNose1",
    cx: 629.3,
    cy: 233.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftUpperLipTop0",
    cx: 635.1,
    cy: 251.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftUpperLipTop1",
    cx: 628.7,
    cy: 250.8,
    r: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "leftMiddleLip",
    d: "M638.4,254.8c0.4,0,0.8,0.4,0.8,0.8c0,0.4-0.4,0.8-0.8,0.8s-0.8-0.4-0.8-0.8S638,254.8,638.4,254.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftUpperLipBottom1",
    cx: 628.5,
    cy: 254.8,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftLowerLipTop0",
    cx: 628.5,
    cy: 257.7,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftLowerLipBottom1",
    cx: 628.7,
    cy: 264.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftLowerLipBottom0",
    cx: 635.6,
    cy: 261.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftEye4",
    cx: 642.8,
    cy: 216.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw7",
    cx: 639.3,
    cy: 287.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw6",
    cx: 649.3,
    cy: 281.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw5",
    cx: 660.9,
    cy: 268.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw4",
    cx: 667.7,
    cy: 248.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw3",
    cx: 668.5,
    cy: 227,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw2",
    cx: 668.5,
    cy: 217.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw1",
    cx: 667.7,
    cy: 205.7,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw0",
    cx: 665.2,
    cy: 196.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st16",
    points: "624.5,170 604.7,172.5 592.2,182 583.6,196.1 581.1,205.4 580.3,217.1 580.3,226.6 581.1,248.3  587.9,268.3 599.5,280.8 609.5,287.5 624.5,290.7 639.3,287.9 649.3,281.2 660.9,268.6 667.7,248.6 668.5,227 668.5,217.4  667.7,205.7 665.2,196.5 657,182 644.4,172.5 624.5,170  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st16",
    points: "588.5,206.9 592.5,203.2 598.7,202.2 606,202.2 615.8,206.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "594.7,215.1 599.9,211.4 606.2,211.4 611.4,215.6 606.2,216.6 599.9,217.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st16",
    points: "613,233.2 618.2,233.2 623.7,234 623.7,228.7 623.7,221.6 623.7,216.1 623.7,210.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st16",
    points: "660,206.5 656,203.6 649.7,202.1 642.4,202.5 632.4,205.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "654.1,215.1 648.8,211.4 642.5,211.4 637.4,215.6 642.5,216.6 648.8,217.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st16",
    points: "634.1,233.2 629.1,233.2 623.7,234  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "607,255.3 613.9,251.9 620.4,250.8 624.5,251.7 628.7,250.8 635.1,251.9 642,255.3 635.6,261.6  628.5,264.4 624.5,264.9 620.4,264.4 613.4,261.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st16",
    points: "607,255.3 610.6,255.6 620.6,254.8 624.5,255.3 628.5,254.8 638.4,255.6 642,255.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st16",
    points: "607,255.3 610.6,255.6 620.6,257.7 624.5,258.5 628.5,257.7 638.4,255.6 642,255.3  "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightTop0",
    cx: 604.8,
    cy: 172.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightTop1",
    cx: 592.2,
    cy: 182,
    r: 0.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlathers);
export default __webpack_public_path__ + "static/media/blathers.80baf17177aad91e12b8a3e450854d3d.svg";
export { ForwardRef as ReactComponent };